<template>
  <div class="main-pc-mass-records">
    <f7-block class="content-mass-records-information">
      <div
        v-if="selectWorkerOption"
        class="padding"
      >
        <f7-checkbox
          :checked="checkAll"
          class="padding-left"
          @change="checkAll = !checkAll; changeCheckedAll($event.target.checked)"
        />
        <span
          class="padding-left"
          :style="[{ color: 'var(--his-slate-blue)' }]"
        > Seleccionar todos </span>
      </div>
      <div
        class="content-mass-records-information__card"
      >
        <div
          v-if="workersList.length > 0"
          class="content-mass-records-information__list-wrapper list media-list"
        >
          <ul class="content-mass-records-information__list-wrapper-ul">
            <VList :data="workersList">
              <template #default="{ item: worker, index }">
                <f7-list-item
                  :key="index"
                  class="margin-horizontal"
                  :class="{ 'red-worker': recordDateForWorker < new Date(worker.TrabajadorElementoProduccion[0]?.FechaInicio) }"
                  :media-item="true"
                  :checkbox="selectWorkerOption"
                  :checked="worker.checked || checkAll"
                  @change="changeChecked(worker, $event.target.checked)"
                >
                  <template #media>
                    <img
                      v-if="!worker.Sujeto?.ImagenPerfil?.Archivo"
                      src="@/static/icons/ic_user.svg"
                    >

                    <img
                      v-else
                      :src="worker.Sujeto.ImagenPerfil.Archivo"
                    >
                  </template>

                  <div class="content-mass-records-information__list">
                    <div class="content-mass-records-information__list--data">
                      <slot
                        name="information"
                        :worker="worker"
                      >
                        <div class="content-mass-records-information__list--data-title title">
                          {{ worker.Sujeto.Nombre }}  {{ worker.GruposTrabajadores.length > 0 ? `(${worker.GruposTrabajadores[0].Descripcion})` : '' }}
                        </div>
                        <div class="content-mass-records-information__list--data-subtitle subtitle">
                          {{ worker.TrabajadorElementoProduccion[0]?.LineaProduccion.Nombre ?? '' }}
                        </div>
                        <div class="content-mass-records-information__list--data-text text">
                          {{ worker.TrabajadorElementoProduccion[0]?.ActividadProduccion.Nombre ?? '' }}
                        </div>
                      </slot>
                    </div>

                    <div class="display-flex flex-direction-row justify-content-space-between align-items-center">
                      <div class="content-mass-records-information__list--time">
                        <span class="content-mass-records-information__list--time-hour"> {{ (worker.TrabajadorElementoProduccion?.[0]?.FechaInicio ? formatTime(worker.TrabajadorElementoProduccion[0].FechaInicio, 'HH:mm') : '--:--') }} </span>
                        <span class="content-mass-records-information__list--time-text"> U.Marcaje </span>
                      </div>
                      <div
                        v-if="deleteWorkerOption"
                        class="content-mass-records-information__list--delete"
                      >
                        <img
                          src="@/static/icons/ic_delete.svg"
                          width="30"
                          @click="deleteOption(worker)"
                        >
                      </div>
                    </div>
                  </div>
                </f7-list-item>
              </template>
            </VList>
          </ul>
        </div>
        <div v-else>
          <span class="content-mass-records-information__list--text"> Añade trabajadores a la lista </span>
        </div>
      </div>
    </f7-block>
  </div>
</template>

<script setup>
// @ts-check
import { HiDateTimeSupport } from '@/js/common/HIConversionSupport';
import { VList } from 'virtua/vue';
import { computed, ref } from 'vue';

/** @import { PropType } from 'vue' */
/** @import { Trabajador } from '@erpagroapp/types' */

/** @typedef {Trabajador & { checked?: boolean }} LocalTrabajador */

const props = defineProps({
  deleteWorkerOption: {
    type: Boolean,
    default: true,
  },
  selectWorkerOption: {
    type: Boolean,
    default: false,
  },
  recordDate: {
    type: String,
    default: '',
  },
});

const emit = defineEmits([
  'delete',
]);

const workersList = defineModel('workersList', {
  type: /** @type {PropType<LocalTrabajador[]>} */ (Array),
  default: () => [],
});

const checkAll = ref(false);

const recordDateForWorker = computed(() => new Date(props.recordDate));

/**
 * @param {string} dateTime
 * @param {string} format
 * @returns {string}
 */
function formatTime(dateTime, format) {
  return HiDateTimeSupport.FormatDateTime(dateTime, format);
}

/**
 * @public
 * @param {LocalTrabajador} worker
 * @param {boolean} value
 * @returns {void}
 */
function changeChecked(worker, value) {
  worker.checked = value;

  let esDiferente = false;
  const checkWorker = workersList.value[0]?.checked ?? false;

  workersList.value.forEach((w) => {
    if (w.checked !== checkWorker) {
      esDiferente = true;
    }
  });

  if (!esDiferente) {
    checkAll.value = checkWorker;
  } else {
    checkAll.value = false;
  }
}

/**
 * @param {boolean} value
 * @returns {void}
 */
function changeCheckedAll(value) {
  workersList.value.forEach((b) => {
    b.checked = value;
  });
}

/**
 * @param {LocalTrabajador} option
 * @returns {void}
 */
function deleteOption(option) {
  emit('delete', option);
}

defineExpose({
  changeChecked,
});
</script>

<style lang="scss">
.main-pc-mass-records {
  --mass-records-list-bg-color: var(--his-metal-tint);

  background-color: white !important;

  .content-mass-records-information {
    height: calc(100vh - var(--f7-page-navbar-offset) - 111px - 60px);
    background-color: #fff;

    &__card {
      height: inherit;
      background-color: var(--mass-records-list-bg-color);

      // height: calc(100vh - var(--f7-page-navbar-offset) - 110px - 53px);
      // padding-left: var(--f7-typography-margin);
      // padding-right: var(--f7-typography-margin);

      .media-item {
        background-color: var(--mass-records-list-bg-color);
      }
    }

    &__list-wrapper {
      height: 100%;
    }

    &__list-wrapper-ul {
      height: 100%;
      background-color: var(--mass-records-list-bg-color);
    }

    &__list {
      display: grid;
      grid-template-columns: 4fr 1fr;
      grid-column-gap: 10px;

      &--data {
        display: flex;
        flex-direction: column;

        &-title {
          color: var(--his-steel-blue);
          font-size: 18px;
        }

        &-subtitle {
          color: var(--his-slate-blue);
          font-size: 16px;
        }

        &-text {
          color: var(--his-ash-gray);
          font-size: 14px;
        }
      }

      &--time {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &-hour {
          color: var(--his-slate-blue);
          font-size: 30px;
        }

        &-text {
          color: var(--his-ash-gray);
          font-size: 13px;
        }
      }

      &--text {
        display: flex;
        justify-content: center;
        color: var(--his-ash-gray);
        font-size: 20px;
      }
    }
  }

  .red-worker {
    background-color: var(--his-tomate-tint) !important;
  }
}
</style>
